{
  "version": 1,
  "asset_id": "c2079b84-e6bf-4c84-a97e-1b7d9939a7a3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/c2079b84-e6bf-4c84-a97e-1b7d9939a7a3/sleeve-fitzer-2.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/c2079b84-e6bf-4c84-a97e-1b7d9939a7a3/sleeve-fitzer-2.webp",
  "original_filename": "sleeve-fitzer-2.webp",
  "size": 21086,
  "content_type": "image/webp",
  "created_at": "2026-08-15T18:29:17Z"
}
